export default __webpack_public_path__ + "static/seo-agentur-stuttgart-erklaerung-d53ba4525500473c07f0a7cbe1d4619b.mp4";